import { isEmpty } from "lodash";
import {
  EPromotionTypes,
  IAction,
  IFilter,
  ECampaignStatus
} from "store/store.interface";
import {
  BUNDLE_PROMOTION_SET_TYPE,
  BUNDLE_PROMOTION_SET_FIELDS,
  BUNDLE_PROMOTION_SET_VALUE,
  BUNDLE_CLEAR_CREATION_BUNDLE_FORM,
  BUNDLE_ADD_NEW_CAMPAGIN_TO_THE_LIST,
  BUNDLE_PROMOTION_SET_CAMPAIGNS,
  BUNDLE_PROMOTION_SET_CAMPAIGN_BY_ID,
  BUNDLE_PROMOTION_UPDATE_STATUS,
  BUNDLE_PROMOTION_UPDATE_CAMPAIGN,
  BUNDLE_PROMOTION_UPDATE_PAGE_NUMBER,
  BUNDLE_PROMOTION_CLEAR_CAMPAIGNS_LIST,
  BUNDLE_PROMOTION_UPDATE_FILTER,
  BUNDLE_PROMOTION_RESET_FILTER,
  RESOURCE_DATA,
} from "../store.types";

export interface IBundlePromotionForm {
  type?: EPromotionTypes;
  name?: string;
  startDate?: Date;
  endDate?: Date;
  description?: string;
  edit?: boolean;
  campaignId?: string;
  couponType?: any;
  status?: ECampaignStatus;
}

export interface IFieldType {
  name: string;
  value: any;
}

export enum EFieldType {
  input = "input",
  select = "select",
  dateRange = "dateRange",
  radioGroup = "radioGroup",
  file = "file",
  checkbox = "checkbox",
}


export type TDefault = {
  field?: any;
  startTime?: string;
  endTime?: string;
};

export type TBundleFieldType = {
  isSingle?: boolean;
  id: string;
  name: string;
  keys: string[];
  label?: string;
  type: EFieldType;
  value?: any;
  optionsType?: string;
  validator?: string;
  maxChar?: number;
  minChar?: number;
  maxNumber?: number;
  minNumber?: number;
  maxYears?: number;
  isVisible?: boolean;
  isEditable?: boolean;
  isRequired?: boolean;
  startDateKeys?: string[];
  endDateKeys?: string[];
  withTiming?: boolean;
  defaultValue?: string | TDefault;
  description?: string;
  errorMessage?: string;
};

export type TApprovalOption = {
  id: string;
  label: string;
  value: string;
  required?: boolean;
};

export type TPoints = {
  label: string
}
export type TLayout = "layout_1" | "layout_2";
export interface IFormDetails {
  header: string;
  title: string;
  layout: TLayout;
  fields: TBundleFieldType[];
}
export interface IQuery {
  limit?: number;
  page?: number;
  filters?: IFilter[];
}
export interface BundleText {
  badge?: string;
  description?: string;
  shortText?: string;
  longText?: string;
  firstTnc?: string;
  secondTnc?: string;
  offerText?: string;
}

export interface BundleInfo {
  mixAndMatch?: boolean;
  quantity?: number;
  discountQuantity?: number;
  text: {
    ar: BundleText;
    en: BundleText;
  };
}
export interface Promotion {
  type: "DISCOUNT";
  discountType: "BXGYFREE";
  amount: number;
}

export interface IBundleDashboard {
  createdBy?: string,
  campaignId: string,
  status?: ECampaignStatus,
  name: string;
  description: string;
  startDate: Date;
  endDate: Date;
  offer: {
    promotion?: Promotion;
    bundleInfo?: BundleInfo;
    posId: string;
  };
  itemInfo: {
    itemList: string[];
  };
  type?: string;
  edit?: boolean;
  updatedBy?: string;
}
export interface IBundlePromotion {
  creationBundleForm: IBundlePromotionForm;
  bundleDashboard?: IBundleDashboard[];
  newBundleCampaign?: IBundleDashboard;
  formDetails?: IFormDetails;
  bundleCampaign?: IBundleDashboard & IBundlePromotionForm;
  filters?: IFilter[];
  page: number;
  total: number;
  posInfoResourceData?: any;
}

export const BUNDLE_PROMOTION_INITIAL_STATE = {
  creationBundleForm: {},
  page: 0,
  total: 0,
};

export default (state: IBundlePromotion = BUNDLE_PROMOTION_INITIAL_STATE, action: IAction) => {
  switch (action.type) {
    case BUNDLE_PROMOTION_SET_TYPE:
      return {
        ...state,
        creationBundleForm: {
          ...state.creationBundleForm,
          type: action.payload
        },
      };
    case BUNDLE_PROMOTION_SET_FIELDS: {
      let dataToInject;
      const data = action.payload;
      if (!isEmpty(data) && Array.isArray(data)) {
        dataToInject = data[0].data;
      }
      return {
        ...state,
        formDetails: dataToInject,
      };
    }
    case BUNDLE_PROMOTION_SET_VALUE:
      return {
        ...state,
        creationBundleForm: {
          ...state.creationBundleForm,
          ...action.payload,
        },
      };
    case BUNDLE_CLEAR_CREATION_BUNDLE_FORM:
      return {
        ...state,
        creationBundleForm: {}
      };
    case BUNDLE_ADD_NEW_CAMPAGIN_TO_THE_LIST:
      return {
        ...state,
        newBundleCampaign: action.payload,
      };
    case BUNDLE_PROMOTION_SET_CAMPAIGNS: {
      const { campaigns } = action.payload;

      const newBundleCampaign = state.newBundleCampaign;
      let dashboardState = [...(state.bundleDashboard || []), ...campaigns];

      if (newBundleCampaign && !dashboardState.find((c) => c.campaignId === newBundleCampaign.campaignId)) {
        dashboardState = [newBundleCampaign, ...dashboardState];
      }
      const total = dashboardState.length;
      return {
        ...state,
        bundleDashboard: dashboardState,
        newBundleCampaign: null,
        total,
      };
    }
    case BUNDLE_PROMOTION_SET_CAMPAIGN_BY_ID:
      return {
        ...state,
        bundleCampaign: action.payload,
      };
    case BUNDLE_PROMOTION_UPDATE_STATUS: {
      const { campaignId: idToUpdate, status: newStatus } = action.payload;
      const { bundleDashboard = [] } = state;
      const newDashboard = bundleDashboard.map((promotion) =>
        promotion.campaignId === idToUpdate
          ? { ...promotion, status: newStatus }
          : promotion
      );
      return {
        ...state,
        bundleDashboard: newDashboard,
        bundleCampaign: {
          ...state.bundleCampaign,
          status: newStatus,
        },
      };
    }
    case BUNDLE_PROMOTION_UPDATE_CAMPAIGN:
      return {
        ...state,
        bundleDashboard: state.bundleDashboard?.map((item) => {
          if (item.campaignId === action.payload.campaignId) {
            return action.payload
          }
          return item;
        })
      }
    case BUNDLE_PROMOTION_UPDATE_PAGE_NUMBER:
      return {
        ...state,
        page: action.payload,
      };
    case BUNDLE_PROMOTION_CLEAR_CAMPAIGNS_LIST:
      return {
        ...state,
        bundleDashboard: [],
        page: 0,
        total: 0,
      };
    case RESOURCE_DATA:
      return {
        ...state,
        posInfoResourceData: action.payload
      };
    case BUNDLE_PROMOTION_UPDATE_FILTER:
      return {
        ...state,
        filters: action.payload,
      };
    case BUNDLE_PROMOTION_RESET_FILTER:
      return {
        ...state,
        filters: [],
      };
    default:
      return state;
  }
};
